module.exports = __webpack_public_path__ + "media/images/costumes/top/dress-brand-1-big-8d308beb4b016d9037512fc26114f19a.jpg";